import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriProductNofificationButtonComponent } from '../../components/gonvarri-product-nofification-button/gonvarri-product-nofification-button.component';
import {IconModule} from "@spartacus/storefront";
import {I18nModule} from "@spartacus/core";



@NgModule({
  declarations: [
    GonvarriProductNofificationButtonComponent
  ],
  exports: [
    GonvarriProductNofificationButtonComponent
  ],
  imports: [
    CommonModule,
    IconModule,
    I18nModule
  ]
})
export class GonvarriProductNofificationButtonModule { }
